import React, { useEffect } from 'react'
import styled from 'styled-components'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import BlockIcon from '@material-ui/icons/Block'
import PanoramaFishEyeIcon from '@material-ui/icons/PanoramaFishEye'
import CancelIcon from '@material-ui/icons/Cancel'

const useStyles = makeStyles(theme => ({
  questionText: {
    fontWeight: 500
  },
  answerText: {
    fontWeight: 300,
    margin: '16px 0'
  },
  incorretAnswerText: {
    fontWeight: 300,
    color: '#f94340'
  },
  commentText: {
    fontWeight: 400,
    backgroundColor: '#d9d9e1'
  }
}))

const FeedbackBox = styled.div`
  width: 100%;
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
`

const TextFields = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 48px;
  &.defaultColor {
    color: #4e4d4d;
  }
  &.invalidColor {
    color: #8b8b8b;
  }
`

const ExamFeedbackFields = ({ perguntas }) => {
  const classes = useStyles()

  useEffect(() => {
    window.MathJax.typeset()
  })

  const handleIcon = answer => {
    if (answer.anulada) {
      return <BlockIcon style={{ color: '#f0aa0e', padding: '0 8px' }} />
    } else if (!answer.respondida) {
      return <PanoramaFishEyeIcon style={{ color: '#8b8b8b', padding: '0 8px' }} />
    } else {
      if (answer.correta) {
        return <CheckCircleIcon style={{ color: '#4cb40b', padding: '0 8px' }} />
      } else {
        return <CancelIcon style={{ color: '#e80206', padding: '0 8px' }} />
      }
    }
  }

  const answerSection = answer => {
    if (answer.anulada) {
      return null
    }

    if (answer.correta || !answer.respondida) {
      return (
        <Typography variant="body1" component="body1" className={classes.answerText}>
          <div
            dangerouslySetInnerHTML={{
              __html: `<em>Resposta: ${((answer || {}).respostaCorreta || '').resposta}</em>`.replace(/<math>|<\/math>/gi, '`')
            }}
          />
        </Typography>
      )
    } else {
      return (
        <div>
          <Typography variant="body1" component="body1" className={classes.incorretAnswerText}>
            <div
              style={{
                margin: '8px 0'
              }}
              dangerouslySetInnerHTML={{
                __html: `<em>Incorreto: ${((answer || {}).respostaAssinalada || '').resposta}</em>`.replace(/<math>|<\/math>/gi, '`')
              }}
            />
          </Typography>
          <Typography variant="body1" component="body1" className={classes.answerText}>
            <div
              dangerouslySetInnerHTML={{
                __html: `<em>Resposta: ${((answer || {}).respostaCorreta || '').resposta}</em>`.replace(/<math>|<\/math>/gi, '`')
              }}
            />
          </Typography>
        </div>
      )
    }
  }

  return perguntas.map(item => (
    <FeedbackBox>
      {handleIcon(item)}
      <TextFields className={item.respondida || item.anulada ? 'defaultColor' : 'invalidColor'}>
        <Typography variant="body1" component="body1" className={classes.questionText}>
          <div
            dangerouslySetInnerHTML={{
              __html: (item.anulada ? '(QUESTÃO ANULADA) ' + item.enunciado : item.enunciado).replace(/<math>|<\/math>/gi, '`')
            }}
          />
        </Typography>
        {answerSection(item)}

        {item.comentario !== ('' && undefined) ? (
          <Typography variant="body1" component="body1" className={classes.commentText}>
            <div dangerouslySetInnerHTML={{ __html: ('<em>COMENTÁRIO:'+ item.comentario +'</em>').replace(/<math>|<\/math>/gi, '`') }} />
          </Typography>
        ) : (
          ''
        )}
      </TextFields>
    </FeedbackBox>
  ))
}

export default ExamFeedbackFields
